(function () {
  'use strict';

  const STYLE_ID = 'mask-brush-editor-style';
  const CSS = `
.mbe-overlay{position:fixed;inset:0;z-index:100000;display:flex;align-items:center;justify-content:center;background:rgba(15,23,42,0.62);backdrop-filter:blur(2px);font-family:Inter,system-ui,sans-serif;}
.mbe-modal{display:flex;flex-direction:column;width:min(1100px,96vw);height:min(800px,94vh);background:#11161f;color:#e8edf5;border-radius:14px;box-shadow:0 24px 80px rgba(0,0,0,0.55);overflow:hidden;}
.mbe-head{display:flex;align-items:center;gap:10px;padding:12px 16px;border-bottom:1px solid rgba(255,255,255,0.08);}
.mbe-head h3{margin:0;font-size:15px;font-weight:800;flex:1;}
.mbe-body{flex:1;display:flex;min-height:0;}
.mbe-stage{flex:1;position:relative;background:#0b0e14;overflow:hidden;}
.mbe-canvas{position:absolute;inset:0;width:100%;height:100%;cursor:crosshair;touch-action:none;}
.mbe-stage.mbe-pan .mbe-canvas{cursor:grab;}
.mbe-stage.mbe-panning .mbe-canvas{cursor:grabbing;}
.mbe-side{width:268px;flex-shrink:0;border-left:1px solid rgba(255,255,255,0.08);padding:14px;display:flex;flex-direction:column;gap:12px;overflow-y:auto;}
.mbe-modes{display:grid;grid-template-columns:1fr 1fr;gap:8px;}
.mbe-mode{padding:12px 8px;border-radius:9px;border:1px solid rgba(255,255,255,0.14);background:#1a212e;color:#cfd8e6;font-weight:800;font-size:13px;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:4px;}
.mbe-mode svg{width:22px;height:22px;}
.mbe-mode small{font-weight:600;font-size:10px;letter-spacing:.02em;opacity:.7;}
.mbe-mode.active[data-mbe-mode="restore"]{border-color:#34d399;color:#34d399;background:#10251c;box-shadow:inset 0 0 0 1px #34d399;}
.mbe-mode.active[data-mbe-mode="erase"]{border-color:#f87171;color:#f87171;background:#2a1414;box-shadow:inset 0 0 0 1px #f87171;}
.mbe-field{display:flex;flex-direction:column;gap:6px;}
.mbe-field label{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.04em;color:#8b97a8;display:flex;justify-content:space-between;align-items:center;gap:8px;}
.mbe-field input[type=range]{width:100%;accent-color:#6aa6ff;}
.mbe-size-num{width:64px;padding:4px 6px;border-radius:6px;border:1px solid rgba(255,255,255,0.16);background:#0b0e14;color:#e8edf5;font-weight:700;font-size:12px;}
.mbe-presets{display:flex;flex-wrap:wrap;gap:4px;}
.mbe-preset{padding:5px 8px;border-radius:7px;border:1px solid rgba(255,255,255,0.14);background:#1a212e;color:#cfd8e6;font-weight:700;font-size:11px;cursor:pointer;}
.mbe-preset:hover,.mbe-preset.active{border-color:#6aa6ff;color:#fff;}
.mbe-preview{height:76px;display:flex;align-items:center;justify-content:center;background:#0b0e14;border-radius:9px;border:1px solid rgba(255,255,255,0.08);}
.mbe-preview-dot{border-radius:50%;box-shadow:0 0 0 1px rgba(255,255,255,0.35);}
.mbe-row{display:grid;grid-template-columns:1fr 1fr;gap:8px;}
.mbe-btn{padding:9px 12px;border-radius:9px;border:1px solid rgba(255,255,255,0.14);background:#1a212e;color:#dbe4f0;font-weight:700;font-size:12px;cursor:pointer;}
.mbe-btn:hover{background:#222b3a;}
.mbe-btn.primary{background:#3b82f6;border-color:#3b82f6;color:#fff;}
.mbe-btn.primary:hover{background:#2f6fe0;}
.mbe-btn.ghost{background:transparent;}
.mbe-spacer{flex:1;}
.mbe-hint{font-size:10.5px;line-height:1.5;color:#6b7688;}
.mbe-hint kbd{display:inline-block;padding:0 4px;border:1px solid rgba(255,255,255,0.18);border-radius:4px;font-size:10px;}
.mbe-foot{display:flex;gap:10px;padding:12px 16px;border-top:1px solid rgba(255,255,255,0.08);align-items:center;}
.mbe-zoom{display:flex;align-items:center;gap:8px;font-size:11px;color:#8b97a8;}
.mbe-zoom button{width:26px;height:26px;border-radius:7px;border:1px solid rgba(255,255,255,0.14);background:#1a212e;color:#dbe4f0;cursor:pointer;font-size:15px;line-height:1;}
.mbe-busy{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(11,14,20,0.6);font-weight:700;}
@media(max-width:720px){.mbe-body{flex-direction:column;}.mbe-side{width:auto;border-left:0;border-top:1px solid rgba(255,255,255,0.08);max-height:43%;}.mbe-modal{height:96vh;}.mbe-preview{display:none;}}
`;

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    const s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function canvasSafeUrl(raw) {
    if (!raw || /^(data:|blob:|about:)/i.test(raw)) return raw;
    try {
      const parsed = new URL(raw, window.location.href);
      if (parsed.origin === window.location.origin) return parsed.href;
      return '/api/img-proxy?url=' + encodeURIComponent(parsed.href);
    } catch (_) {
      return raw;
    }
  }

  function loadImage(url) {
    return new Promise((resolve, reject) => {
      if (!url) {
        reject(new Error('no url'));
        return;
      }
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error('load failed'));
      img.crossOrigin = 'anonymous';
      img.src = canvasSafeUrl(url);
    });
  }

  function capsuleCoverage(px, py, from, to, inner, radius) {
    const dx = to.x - from.x;
    const dy = to.y - from.y;
    const lengthSquared = dx * dx + dy * dy;
    const t = lengthSquared
      ? Math.max(0, Math.min(1, ((px - from.x) * dx + (py - from.y) * dy) / lengthSquared))
      : 0;
    const distance = Math.hypot(px - (from.x + dx * t), py - (from.y + dy * t));
    if (distance >= radius) return 0;
    if (distance <= inner || radius <= inner) return 1;
    const edge = (radius - distance) / (radius - inner);
    return edge * edge * (3 - 2 * edge);
  }

  const SIZE_PRESETS = [8, 16, 32, 48, 80, 128, 256];

  function clampSize(n) {
    return Math.max(4, Math.min(400, Math.round(Number(n) || 0)));
  }

  function MaskBrushEditor(opts) {
    this.opts = opts || {};
    this.mode = this.opts.initialMode === 'restore' ? 'restore' : 'erase';
    this.sizes = { erase: 48, restore: 28 };
    this.softnesses = { erase: 18, restore: 42 };
    this.brushSize = this.sizes[this.mode];
    this.softness = this.softnesses[this.mode];
    this.strength = 100;
    this.strokeMode = this.mode;
    this.scale = 1;
    this.offsetX = 0;
    this.offsetY = 0;
    this.panMode = false;
    this.panning = false;
    this.painting = false;
    this.last = null;
    this.cursor = null;
    this.undoStack = [];
    this.maxUndo = 16;
  }

  MaskBrushEditor.prototype.open = async function () {
    injectStyle();
    this.buildDom();
    try {
      const cutout = await loadImage(this.opts.imageUrl);
      let base = cutout;
      if (
        this.opts.originalUrl &&
        this.opts.originalUrl !== this.opts.imageUrl
      ) {
        base = await loadImage(this.opts.originalUrl);
      }
      this.initCanvases(base, cutout);
      this.busy.remove();
      this.resizeCanvas();
      this.fitView();
      this.render();
    } catch (error) {
      this.busy.textContent = 'Could not load image';
      if (typeof this.opts.onError === 'function') this.opts.onError(error);
    }
  };

  MaskBrushEditor.prototype.buildDom = function () {
    const self = this;
    const overlay = document.createElement('div');
    overlay.className = 'mbe-overlay';
    overlay.innerHTML = `
<div class="mbe-modal" role="dialog" aria-label="Refine cutout">
  <div class="mbe-head">
    <h3>${this.opts.title || 'Refine Cutout'}</h3>
    <button class="mbe-btn ghost" data-mbe="close">Close</button>
  </div>
  <div class="mbe-body">
    <div class="mbe-stage"><canvas class="mbe-canvas"></canvas><div class="mbe-busy">Loading…</div></div>
    <div class="mbe-side">
      <div class="mbe-modes">
        <button class="mbe-mode" data-mbe-mode="erase" type="button"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 20h16"/><path d="m6 16 8-8 4 4-8 8z"/><path d="m11 7 3 3"/></svg>Eraser<small>Remove · E</small></button>
        <button class="mbe-mode" data-mbe-mode="restore" type="button"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3v6"/><path d="m8.5 6.5 3.5-3.5 3.5 3.5"/><path d="M5 13a7 7 0 1 0 14 0"/></svg>Restore Brush<small>Paint back · R</small></button>
      </div>
      <div class="mbe-preview" aria-hidden="true"><div class="mbe-preview-dot" data-mbe="preview"></div></div>
      <div class="mbe-field">
        <label>Size <span><input class="mbe-size-num" type="number" min="4" max="400" step="1" value="48" data-mbe="sizenums"> px</span></label>
        <input type="range" min="4" max="400" step="1" value="48" data-mbe="size">
        <div class="mbe-presets" data-mbe="presets"></div>
      </div>
      <div class="mbe-field">
        <label>Edge feather <span data-mbe="softval">18</span></label>
        <input type="range" min="0" max="100" step="1" value="18" data-mbe="soft">
      </div>
      <div class="mbe-field">
        <label>Strength <span data-mbe="strval">100</span></label>
        <input type="range" min="5" max="100" step="1" value="100" data-mbe="str">
      </div>
      <div class="mbe-row">
        <button class="mbe-btn" data-mbe="undo" type="button">Undo</button>
        <button class="mbe-btn" data-mbe="reset" type="button">Reset</button>
      </div>
      <button class="mbe-btn ghost" data-mbe="pan" type="button">Pan / Move (Space)</button>
      <div class="mbe-spacer"></div>
      <div class="mbe-hint">Eraser removes pixels. Restore Brush paints source pixels back. Strokes use a smooth signed-distance edge. <kbd>E</kbd> eraser, <kbd>R</kbd> restore, <kbd>[</kbd> <kbd>]</kbd> size, Alt or right-click to erase.</div>
    </div>
  </div>
  <div class="mbe-foot">
    <div class="mbe-zoom"><button data-mbe="zoomout" type="button">-</button><span data-mbe="zoomval">100%</span><button data-mbe="zoomin" type="button">+</button><button data-mbe="zoomfit" type="button" title="Fit">Fit</button></div>
    <div class="mbe-spacer"></div>
    <button class="mbe-btn ghost" data-mbe="cancel" type="button">Cancel</button>
    <button class="mbe-btn primary" data-mbe="apply" type="button">${this.opts.applyLabel || 'Apply'}</button>
  </div>
</div>`;
    document.body.appendChild(overlay);
    this.overlay = overlay;
    this.stage = overlay.querySelector('.mbe-stage');
    this.canvas = overlay.querySelector('.mbe-canvas');
    this.ctx = this.canvas.getContext('2d');
    this.busy = overlay.querySelector('.mbe-busy');

    const q = (s) => overlay.querySelector(`[data-mbe="${s}"]`);
    this.sizeRange = q('size');
    this.sizeNum = q('sizenums');
    this.softVal = q('softval');
    this.strVal = q('strval');
    this.zoomVal = q('zoomval');
    this.previewDot = q('preview');
    this.presetsEl = q('presets');
    SIZE_PRESETS.forEach((n) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'mbe-preset';
      b.textContent = String(n);
      b.dataset.size = String(n);
      b.addEventListener('click', () => self.setBrushSize(n));
      self.presetsEl.appendChild(b);
    });

    overlay.querySelectorAll('[data-mbe-mode]').forEach((btn) => {
      btn.addEventListener('click', () => self.setMode(btn.dataset.mbeMode));
    });
    const onSize = (e) => self.setBrushSize(e.target.value);
    q('size').addEventListener('input', onSize);
    q('sizenums').addEventListener('input', onSize);
    q('sizenums').addEventListener('change', onSize);
    q('soft').addEventListener('input', (e) => {
      self.softness = Number(e.target.value);
      self.softnesses[self.mode] = self.softness;
      self.softVal.textContent = self.softness;
      self.syncPreview();
    });
    q('str').addEventListener('input', (e) => {
      self.strength = Number(e.target.value);
      self.strVal.textContent = self.strength;
      self.syncPreview();
    });
    q('undo').addEventListener('click', () => self.undo());
    q('reset').addEventListener('click', () => self.reset());
    q('pan').addEventListener('click', () => self.togglePan());
    q('zoomin').addEventListener('click', () => self.zoomBy(1.25));
    q('zoomout').addEventListener('click', () => self.zoomBy(0.8));
    q('zoomfit').addEventListener('click', () => {
      self.fitView();
      self.render();
    });
    q('apply').addEventListener('click', () => self.apply());
    q('cancel').addEventListener('click', () => self.close(false));
    q('close').addEventListener('click', () => self.close(false));

    this.bindPointer();
    this.onKey = (e) => {
      if (e.target && (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA')) return;
      if (e.code === 'Space' && !self.painting) {
        self.panMode = true;
        self.stage.classList.add('mbe-pan');
        e.preventDefault();
      } else if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'z') {
        e.preventDefault();
        self.undo();
      } else if (e.key === 'Escape') {
        self.close(false);
      } else if (e.key === '[' ) {
        self.adjustSize(-12);
      } else if (e.key === ']') {
        self.adjustSize(12);
      } else if (e.key.toLowerCase() === 'e' && !e.ctrlKey && !e.metaKey) {
        self.setMode('erase');
      } else if (e.key.toLowerCase() === 'r' && !e.ctrlKey && !e.metaKey) {
        self.setMode('restore');
      }
    };
    this.onKeyUp = (e) => {
      if (e.code === 'Space') {
        self.panMode = false;
        self.stage.classList.remove('mbe-pan');
      }
    };
    window.addEventListener('keydown', this.onKey);
    window.addEventListener('keyup', this.onKeyUp);
    this.onResize = () => {
      self.resizeCanvas();
      self.render();
    };
    window.addEventListener('resize', this.onResize);
    requestAnimationFrame(() => self.resizeCanvas());
    this.setMode(this.mode);
    this.syncSizeUI();
    this.syncPreview();
  };

  MaskBrushEditor.prototype.initCanvases = function (base, cutout) {
    const maxDim = 2048;
    let w = cutout.naturalWidth || cutout.width;
    let h = cutout.naturalHeight || cutout.height;
    const cap = Math.max(w, h);
    if (cap > maxDim) {
      const r = maxDim / cap;
      w = Math.round(w * r);
      h = Math.round(h * r);
    }
    this.imgW = w;
    this.imgH = h;

    this.baseCanvas = document.createElement('canvas');
    this.baseCanvas.width = w;
    this.baseCanvas.height = h;
    this.baseCanvas.getContext('2d').drawImage(base, 0, 0, w, h);

    this.maskCanvas = document.createElement('canvas');
    this.maskCanvas.width = w;
    this.maskCanvas.height = h;
    const mctx = this.maskCanvas.getContext('2d');
    mctx.drawImage(cutout, 0, 0, w, h);
    mctx.globalCompositeOperation = 'source-in';
    mctx.fillStyle = '#fff';
    mctx.fillRect(0, 0, w, h);
    mctx.globalCompositeOperation = 'source-over';
    this.initialMask = mctx.getImageData(0, 0, w, h);

    this.outCanvas = document.createElement('canvas');
    this.outCanvas.width = w;
    this.outCanvas.height = h;
    this.outCtx = this.outCanvas.getContext('2d');

    this.checker = this.buildChecker();
  };

  MaskBrushEditor.prototype.buildChecker = function () {
    const c = document.createElement('canvas');
    c.width = 24;
    c.height = 24;
    const x = c.getContext('2d');
    x.fillStyle = '#2a3140';
    x.fillRect(0, 0, 24, 24);
    x.fillStyle = '#363f50';
    x.fillRect(0, 0, 12, 12);
    x.fillRect(12, 12, 12, 12);
    return x.createPattern(c, 'repeat');
  };

  MaskBrushEditor.prototype.composeOut = function () {
    const o = this.outCtx;
    o.clearRect(0, 0, this.imgW, this.imgH);
    o.globalCompositeOperation = 'source-over';
    o.drawImage(this.baseCanvas, 0, 0);
    o.globalCompositeOperation = 'destination-in';
    o.drawImage(this.maskCanvas, 0, 0);
    o.globalCompositeOperation = 'source-over';
  };

  MaskBrushEditor.prototype.resizeCanvas = function () {
    const r = this.stage.getBoundingClientRect();
    const dpr = window.devicePixelRatio || 1;
    this.canvas.width = Math.max(1, Math.round(r.width * dpr));
    this.canvas.height = Math.max(1, Math.round(r.height * dpr));
    this.viewW = r.width;
    this.viewH = r.height;
    this.dpr = dpr;
  };

  MaskBrushEditor.prototype.fitView = function () {
    if (!this.imgW) return;
    const pad = 32;
    const sx = (this.viewW - pad) / this.imgW;
    const sy = (this.viewH - pad) / this.imgH;
    this.scale = Math.min(sx, sy) || 1;
    this.offsetX = (this.viewW - this.imgW * this.scale) / 2;
    this.offsetY = (this.viewH - this.imgH * this.scale) / 2;
  };

  MaskBrushEditor.prototype.render = function () {
    if (!this.imgW) return;
    this.composeOut();
    const ctx = this.ctx;
    const dpr = this.dpr || 1;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, this.viewW, this.viewH);
    ctx.imageSmoothingEnabled = true;
    const x = this.offsetX;
    const y = this.offsetY;
    const w = this.imgW * this.scale;
    const h = this.imgH * this.scale;
    ctx.save();
    ctx.beginPath();
    ctx.rect(x, y, w, h);
    ctx.clip();
    ctx.fillStyle = this.checker;
    ctx.fillRect(x, y, w, h);
    ctx.drawImage(this.outCanvas, x, y, w, h);
    ctx.restore();
    ctx.strokeStyle = 'rgba(255,255,255,0.25)';
    ctx.lineWidth = 1;
    ctx.strokeRect(x + 0.5, y + 0.5, w, h);
    if (this.cursor && !this.panMode) {
      const rad = (this.brushSize / 2) * this.scale;
      const erase = this.strokeMode === 'erase';
      ctx.beginPath();
      ctx.arc(this.cursor.x, this.cursor.y, rad, 0, Math.PI * 2);
      ctx.fillStyle = erase ? 'rgba(248,113,113,0.18)' : 'rgba(52,211,153,0.18)';
      ctx.fill();
      ctx.strokeStyle = erase ? 'rgba(248,113,113,0.95)' : 'rgba(52,211,153,0.95)';
      ctx.lineWidth = 2;
      ctx.stroke();
    }
  };

  MaskBrushEditor.prototype.setBrushSize = function (n) {
    this.brushSize = clampSize(n);
    this.sizes[this.mode] = this.brushSize;
    this.syncSizeUI();
    this.syncPreview();
    this.render();
  };

  MaskBrushEditor.prototype.syncSizeUI = function () {
    if (this.sizeRange) this.sizeRange.value = this.brushSize;
    if (this.sizeNum) this.sizeNum.value = this.brushSize;
    if (this.presetsEl) {
      this.presetsEl.querySelectorAll('.mbe-preset').forEach((b) => {
        b.classList.toggle('active', Number(b.dataset.size) === this.brushSize);
      });
    }
  };

  MaskBrushEditor.prototype.syncPreview = function () {
    if (!this.previewDot) return;
    const px = Math.max(6, Math.min(64, this.brushSize * 0.55));
    const erase = this.mode === 'erase';
    this.previewDot.style.width = px + 'px';
    this.previewDot.style.height = px + 'px';
    this.previewDot.style.background = erase
      ? `rgba(248,113,113,${0.25 + (this.strength / 100) * 0.55})`
      : `rgba(52,211,153,${0.25 + (this.strength / 100) * 0.55})`;
    this.previewDot.style.boxShadow = erase
      ? '0 0 0 2px rgba(248,113,113,0.9)'
      : '0 0 0 2px rgba(52,211,153,0.9)';
  };

  MaskBrushEditor.prototype.setMode = function (mode) {
    if (mode !== 'erase' && mode !== 'restore') return;
    this.mode = mode;
    this.strokeMode = mode;
    this.brushSize = this.sizes[mode];
    this.softness = this.softnesses[mode];
    this.overlay.querySelectorAll('[data-mbe-mode]').forEach((b) => {
      b.classList.toggle('active', b.dataset.mbeMode === mode);
    });
    const soft = this.overlay.querySelector('[data-mbe="soft"]');
    if (soft) soft.value = this.softness;
    if (this.softVal) this.softVal.textContent = this.softness;
    this.syncSizeUI();
    this.syncPreview();
    this.render();
  };

  MaskBrushEditor.prototype.togglePan = function () {
    this.panMode = !this.panMode;
    this.stage.classList.toggle('mbe-pan', this.panMode);
  };

  MaskBrushEditor.prototype.adjustSize = function (d) {
    this.setBrushSize(this.brushSize + d);
  };

  MaskBrushEditor.prototype.toImage = function (clientX, clientY) {
    const r = this.canvas.getBoundingClientRect();
    const vx = clientX - r.left;
    const vy = clientY - r.top;
    return {
      x: (vx - this.offsetX) / this.scale,
      y: (vy - this.offsetY) / this.scale,
      vx,
      vy,
    };
  };

  MaskBrushEditor.prototype.bindPointer = function () {
    const self = this;
    const cv = this.canvas;
    cv.addEventListener('contextmenu', (e) => e.preventDefault());
    cv.addEventListener('pointerdown', (e) => {
      cv.setPointerCapture(e.pointerId);
      if (self.panMode || e.button === 1) {
        self.panning = true;
        self.stage.classList.add('mbe-panning');
        self.panStart = {
          x: e.clientX,
          y: e.clientY,
          ox: self.offsetX,
          oy: self.offsetY,
        };
        return;
      }
      if (e.button !== 0 && e.button !== 2) return;
      self.strokeMode = e.button === 2 || e.altKey ? 'erase' : self.mode;
      self.pushUndo();
      self.painting = true;
      const p = self.toImage(e.clientX, e.clientY);
      self.last = p;
      self.stamp(p, p);
      self.render();
    });
    cv.addEventListener('pointermove', (e) => {
      const p = self.toImage(e.clientX, e.clientY);
      self.cursor = { x: p.vx, y: p.vy };
      if (!self.painting) {
        self.strokeMode = e.altKey ? 'erase' : self.mode;
      }
      if (self.panning && self.panStart) {
        self.offsetX = self.panStart.ox + (e.clientX - self.panStart.x);
        self.offsetY = self.panStart.oy + (e.clientY - self.panStart.y);
        self.render();
        return;
      }
      if (self.painting) {
        self.stamp(self.last, p);
        self.last = p;
      }
      self.render();
    });
    const end = () => {
      self.painting = false;
      self.panning = false;
      self.last = null;
      self.strokeMode = self.mode;
      self.stage.classList.remove('mbe-panning');
    };
    cv.addEventListener('pointerup', end);
    cv.addEventListener('pointercancel', end);
    cv.addEventListener('pointerleave', () => {
      self.cursor = null;
      self.render();
    });
    cv.addEventListener(
      'wheel',
      (e) => {
        e.preventDefault();
        const factor = e.deltaY < 0 ? 1.12 : 0.89;
        self.zoomAt(e.clientX, e.clientY, factor);
      },
      { passive: false }
    );
  };

  MaskBrushEditor.prototype.zoomAt = function (clientX, clientY, factor) {
    const r = this.canvas.getBoundingClientRect();
    const vx = clientX - r.left;
    const vy = clientY - r.top;
    const ix = (vx - this.offsetX) / this.scale;
    const iy = (vy - this.offsetY) / this.scale;
    this.scale = Math.max(0.05, Math.min(12, this.scale * factor));
    this.offsetX = vx - ix * this.scale;
    this.offsetY = vy - iy * this.scale;
    this.zoomVal.textContent = Math.round(this.scale * 100) + '%';
    this.render();
  };

  MaskBrushEditor.prototype.zoomBy = function (factor) {
    this.zoomAt(
      this.canvas.getBoundingClientRect().left + this.viewW / 2,
      this.canvas.getBoundingClientRect().top + this.viewH / 2,
      factor
    );
  };

  MaskBrushEditor.prototype.stamp = function (from, to) {
    const mctx = this.maskCanvas.getContext('2d');
    const radius = this.brushSize / 2;
    const soft = this.softness / 100;
    const inner = Math.max(0, radius * (1 - soft));
    const strength = this.strength / 100;
    const erase = this.strokeMode === 'erase';
    const left = Math.max(0, Math.floor(Math.min(from.x, to.x) - radius - 1));
    const top = Math.max(0, Math.floor(Math.min(from.y, to.y) - radius - 1));
    const right = Math.min(this.imgW, Math.ceil(Math.max(from.x, to.x) + radius + 1));
    const bottom = Math.min(this.imgH, Math.ceil(Math.max(from.y, to.y) + radius + 1));
    const width = right - left;
    const height = bottom - top;
    if (width <= 0 || height <= 0) return;
    const image = mctx.getImageData(left, top, width, height);
    for (let y = 0; y < height; y++) {
      for (let x = 0; x < width; x++) {
        const coverage = capsuleCoverage(left + x + 0.5, top + y + 0.5, from, to, inner, radius);
        if (!coverage) continue;
        const index = (y * width + x) * 4;
        const current = image.data[index + 3] / 255;
        const amount = coverage * strength;
        const next = erase ? current * (1 - amount) : current + (1 - current) * amount;
        image.data[index] = 255;
        image.data[index + 1] = 255;
        image.data[index + 2] = 255;
        image.data[index + 3] = Math.round(next * 255);
      }
    }
    mctx.putImageData(image, left, top);
  };

  MaskBrushEditor.prototype.pushUndo = function () {
    try {
      const snap = this.maskCanvas
        .getContext('2d')
        .getImageData(0, 0, this.imgW, this.imgH);
      this.undoStack.push(snap);
      if (this.undoStack.length > this.maxUndo) this.undoStack.shift();
    } catch (_) {}
  };

  MaskBrushEditor.prototype.undo = function () {
    const snap = this.undoStack.pop();
    if (!snap) return;
    this.maskCanvas.getContext('2d').putImageData(snap, 0, 0);
    this.render();
  };

  MaskBrushEditor.prototype.reset = function () {
    if (!this.initialMask) return;
    this.pushUndo();
    this.maskCanvas.getContext('2d').putImageData(this.initialMask, 0, 0);
    this.render();
  };

  MaskBrushEditor.prototype.apply = function () {
    const self = this;
    this.composeOut();
    try {
      this.outCanvas.toBlob((blob) => {
        if (!blob) {
          if (typeof self.opts.onError === 'function') self.opts.onError(new Error('export failed'));
          return;
        }
        let dataUrl = '';
        try {
          dataUrl = self.outCanvas.toDataURL('image/png');
        } catch (_) {}
        if (typeof self.opts.onApply === 'function') {
          self.opts.onApply(blob, dataUrl);
        }
        self.close(true);
      }, 'image/png');
    } catch (err) {
      if (typeof self.opts.onError === 'function') self.opts.onError(err);
      self.close(false);
    }
  };

  MaskBrushEditor.prototype.close = function (applied) {
    window.removeEventListener('keydown', this.onKey);
    window.removeEventListener('keyup', this.onKeyUp);
    window.removeEventListener('resize', this.onResize);
    if (this.overlay && this.overlay.parentNode) {
      this.overlay.parentNode.removeChild(this.overlay);
    }
    if (!applied && typeof this.opts.onCancel === 'function')
      this.opts.onCancel();
  };

  window.MaskBrushEditor = {
    open(opts) {
      const ed = new MaskBrushEditor(opts);
      ed.open();
      return ed;
    },
    clampSize: clampSize,
    canvasSafeUrl: canvasSafeUrl,
    capsuleCoverage: capsuleCoverage,
  };
})();
